export const SIGNALR = "SIGNALR";
export const SIGNALR_SUCCESS = "SIGNALR_SUCCESS";
export const SIGNALR_ERROR = "SIGNALR_ERROR";
